export { useUpgradeCelebrationModalContentfulData } from './useUpgradeCelebrationModalContentfulData';
